import { createContext, useContext, useEffect, useState } from 'react';
import { api } from './api';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('fitness_token');
        const storedUser = localStorage.getItem('fitness_user');
        if (token && storedUser) {
            try { setUser(JSON.parse(storedUser)); } catch (_) {}
            api.get('/auth/me')
                .then((r) => { setUser(r.data); localStorage.setItem('fitness_user', JSON.stringify(r.data)); })
                .catch(() => { localStorage.removeItem('fitness_token'); localStorage.removeItem('fitness_user'); setUser(null); })
                .finally(() => setLoading(false));
        } else {
            setLoading(false);
        }
    }, []);

    const login = async (email, password) => {
        const r = await api.post('/auth/login', { email, password });
        localStorage.setItem('fitness_token', r.data.access_token);
        localStorage.setItem('fitness_user', JSON.stringify(r.data.user));
        setUser(r.data.user);
        return r.data.user;
    };

    const register = async (email, password, name) => {
        const r = await api.post('/auth/register', { email, password, name });
        localStorage.setItem('fitness_token', r.data.access_token);
        localStorage.setItem('fitness_user', JSON.stringify(r.data.user));
        setUser(r.data.user);
        return r.data.user;
    };

    const logout = () => {
        localStorage.removeItem('fitness_token');
        localStorage.removeItem('fitness_user');
        setUser(null);
        window.location.href = '/login';
    };

    return (
        <AuthCtx.Provider value={{ user, loading, login, register, logout }}>
            {children}
        </AuthCtx.Provider>
    );
}

export const useAuth = () => useContext(AuthCtx);
